export default __webpack_public_path__ + "static/media/logo.b9d53c2a.png";